let baseUrlt = '' // 接口URL
    , baseUrlx = 'https://api.xixunyun.com/' // 接口URL
    , baseUrlq = 'https://api.qxiaoyun.com/' // 接口URL
    , baseUrld = 'https://dcwj.xixunyun.cn/' // 接口URL
    , pageUrl = '' // 企业端网址
    , dcwjUrl = 'https://dcwj.xixunyun.cn' // 企业端网址
    , downUrl = 'https://sxsapi.qxiaoyun.com/'//下载模板域名
    , xxH5Url = 'https://dingding.xixunyun.com/'
switch (location.hostname) {
    // 本地环境url
    case 'localhost':
        // baseUrl = "https://test_api.zjtoutiao.cn/";
        baseUrlt = `http://${location.hostname}:3344/`;
        baseUrld = `http://${location.hostname}:3344/`;
        // pageUrl = 'https://www.baidu.com'
        break;
    case '192.168.0.130':
        // baseUrl = "https://test_api.zjtoutiao.cn/";
        baseUrlt = `http://${location.hostname}:3344/`;
        // pageUrl = 'https://www.baidu.com'
        break;
    case '127.0.0.1':
        baseUrlt = `http://127.0.0.1:90/`;
        break;
    default:
        baseUrlt = "https://sxsapi.qxiaoyun.com/";
    // pageUrl = 'https://www.baidu.com'

}
// baseUrlt = "http://localhost:3344/"
// baseUrlt = "https://sxsapi.qxiaoyun.com/"
// baseUrlx = "http://api.xixunyun.com/" 
export {
    baseUrlt, baseUrlx, baseUrlq, pageUrl, dcwjUrl, baseUrld, downUrl,xxH5Url
};